import assert from "assert";

// Index is inherent to logon identity
export class IQuestionnaireStratPlanDataStore {
    create() {
        assert(false, 'QuestionnaireStratPlanDataStore.create function not implimented')
    }

    retrieve(){
        assert(false, 'QuestionnaireStratPlanDataStore.retrieve function not implimented')
    }

    store(){
        assert(false, 'QuestionnaireStratPlanDataStore.store function not implimented')
    }
}

export default IQuestionnaireStratPlanDataStore